.modal {
	position: fixed;
	top: 50%;
	left: 50%;
	translate: -50% -50%;
	border: none;
	border-radius: var(--radius-xl);
	box-shadow: var(--shadow-lg);
	width: 100%;
	max-width: var(--max-width, 40rem);
	overflow-y: hidden;
	overflow-x: clip;
	background-color: var(--color-surface);
	flex-direction: column;

	&[open] {
		display: flex;
	}

	&::backdrop {
		background-color: rgb(from black r g b / 80%);
	}
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: var(--size-7);
	border-bottom: var(--size-border) solid var(--color-border);

	/* prevent header from shrinking if close button is hidden;
	   box-sizing: content-box lets us use the height of the close button excluding padding */
	box-sizing: content-box;
	min-height: var(--size-8);

	.title {
		overflow: clip;
		white-space: nowrap;
		text-overflow: ellipsis;
		min-width: 0;
	}
}

.close {
	padding: var(--size-2);
	display: block;
	border: none;
	background-color: transparent;
	opacity: 0.5;
	transition: opacity 0.1s ease;

	&:hover {
		opacity: 1;
	}
}

.content {
	padding: var(--size-7);
	overflow: auto;
}

.actions {
	padding: var(--size-7);
	padding-top: 0;
}

/* enter and leave animations */

.modal {
	--duration: 0.3s;
	opacity: 0;
	scale: 0.8;
	transition:
		opacity calc(var(--duration) / 2) ease,
		scale var(--duration) ease,
		overlay var(--duration) ease allow-discrete,
		display var(--duration) ease allow-discrete;

	&::backdrop {
		opacity: 0;
		transition: opacity calc(var(--duration) / 2) ease;
	}

	&[open] {
		opacity: 1;
		scale: 1;

		@starting-style {
			opacity: 0;
			scale: 0.8;
		}

		&::backdrop {
			opacity: 1;

			@starting-style {
				opacity: 0;
			}
		}
	}
}
